import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonSearchbar } from '@ionic/angular';

@Component({
  selector: 'app-new-search-bar',
  templateUrl: './new-search-bar.component.html',
  styleUrls: ['./new-search-bar.component.scss'],
})
export class NewSearchBarComponent {
  searchTerm: string;
  @Output() handleSearch = new EventEmitter();
  @Input() placeholder: string;

  constructor() {}

  search(searchTerm: IonSearchbar) {
    this.searchTerm = searchTerm?.value;
    this.handleSearch.emit(this.searchTerm);
  }
}
